<template>
  <b-overlay :show="searchingConfig">
    <div>
      <form
        data-vv-scope="flow-part-1"
        @submit.prevent
      >
        <div class="row mb-3">
          <div class="col-12">
            <h4>Datos para el flujo</h4>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <vs-input
              class="w-100"
              label="Nombre para el flujo (*)"
              maxlength="120"
              name="name"
              v-model="step.name"
              :danger="errors.has('flow-part-1.name')"
              :danger-text="errors.first('flow-part-1.name')"
              v-validate="'required'"
            />
          </div>
          <div class="col-md-6">
            <vs-input
              class="w-100"
              label="Descripción para el flujo (*)"
              name="description"
              v-model="step.description"
              :danger="errors.has('flow-part-1.description')"
              :danger-text="errors.first('flow-part-1.description')"
              v-validate="'required'"
              maxlength="550"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div
            v-if="!isConvention"
            class="col-md-6 mt-3"
          >
            <div
              data-cy="stamp-approvals"
              class="row"
              v-if="!step.oldFlow"
            >
              <div class="col-md-8 d-flex align-items-end">
                <label>Estampar aprobaciones</label>
                <InfoApprovalStamp/>
              </div>
              <div class="col-md-2">
                <vs-radio
                  vs-name="pdfStamp"
                  :vs-value="true"
                  v-model="step.pdfStamp"
                  data-cy="pdfStampYes"
                >
                  Si
                </vs-radio>
              </div>
              <div class="col-md-2">
                <vs-radio
                  vs-name="pdfStamp"
                  :vs-value="false"
                  v-model="step.pdfStamp"
                  data-cy="pdfStampNo"
                >
                  No
                </vs-radio>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div
              class="row"
              data-cy="private-stream">
              <div class="col-md-8 d-flex align-items-end">
                <label>Flujo privado</label>
                <InfoPrivateFlow/>
              </div>
              <div class="col-md-2">
                <vs-radio
                  vs-name="private"
                  :vs-value="true"
                  v-model="step.private"
                  data-cy="privateYes"
                >
                  Si
                </vs-radio>
              </div>
              <div class="col-md-2">
                <vs-radio
                  vs-name="private"
                  :vs-value="false"
                  v-model="step.private"
                  data-cy="privateNo"
                >
                  No
                </vs-radio>
              </div>
            </div>
          </div>
          <div
            v-if="!step.oldFlow"
            class="col-md-6 mt-3"
          >
            <BooleanParameter
              :is-approval-sign="true"
              data-cy='define-signature-location'
              :disabled="disableSignaturePosition"
              param-id="aprobaciones.firmas.ubicacion"
              v-model="step.setSignaturePosition"
              @input="onSetSignaturePositionChange"
            />
          </div>
          <div class="col-md-6 mt-3">
            <div
              class="row"
              data-cy="Do-you-want-to-base-yourself-on-a-current-flow?"
            >
              <div class="col-md-8 d-flex align-items-end">
                <label>¿Quieres basarte en un flujo actual?</label>
                <InfoOldApproval/>
              </div>
              <div class="col-md-2">
                <vs-radio
                  vs-name="oldFlow"
                  :vs-value="true"
                  v-model="step.oldFlow"
                  data-cy="oldFlowYes"
                >
                  Si
                </vs-radio>
              </div>
              <div class="col-md-2">
                <vs-radio
                  vs-name="oldFlow"
                  :vs-value="false"
                  v-model="step.oldFlow"
                  data-cy="oldFlowNo"
                >
                  No
                </vs-radio>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3" v-if="step.oldFlow">
            <div
              class="row"
              data-cy="plantilla-tipo"
            >
              <div class="col-md-12 d-flex align-items-end">
                <label>¿Que plantillas quieres ver?</label>
                <div class="text-right">
                  <b-button
                    size="sm"
                    class="btn-icon rounded-circle mt-1"
                    id="popover-attended"
                    variant="flat-primary"
                  >
                    <feather-icon icon="InfoIcon"/>
                  </b-button>
                  <b-popover
                    target="popover-attended"
                    triggers="focus"
                    placement="top"
                  >
                    <template #title>
                      <span>Tipo de plantilla!</span>
                    </template>
                    <span>
                      <strong>Atendidas:</strong>
                      Flujos con interacción humana en donde cada participante debe realizar sus acciones
                    </span>
                    <br>
                    <span>
                      <strong>
                        Desatendidas:
                      </strong>
                      Flujos sin interacción humana que se procesan automáticamente
                    </span>
                  </b-popover>
                </div>
              </div>
            </div>
            <div
              class="row"
              data-cy="plantilla-tipo-opciones"
            >
              <div class="col-md-6">
                <vs-radio
                  vs-name="attendedOnly"
                  :vs-value="0"
                  v-model="attendedOnly"
                  data-cy="attendedOnly-0"
                >
                  Atendidas
                </vs-radio>
              </div>
              <div class="col-md-6">
                <vs-radio
                  vs-name="attendedOnly"
                  :disabled="disableDesattendedOnly"
                  :vs-value="1"
                  v-model="attendedOnly"
                  data-cy="attendedOnly-1"
                >
                  Desatendidas
                </vs-radio>
              </div>
            </div>
          </div>
          <div
            class="col-md-6 mt-3"
            v-if="step.oldFlow"
          >
            <label for="flow-select">
              Selecciona el flujo
            </label>
            <v-select
              v-model="step.flowId"
              :options="filteredApprovalsTemplates"
              name="flow-select"
              id="flow-select"
              label="nombre"
              data-cy="select-template"
              placeholder="Selecciona el flujo"
              :reduce="option => option.id"
            >
              <template v-slot:option="{id,nombre}">
                <span
                  :data-cy-value="id"
                  :data-cy-label="nombre"
                >
                  {{ nombre }}
                </span>
              </template>
              <template slot="no-options">
                no hay flujos
              </template>
            </v-select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6 col-xs-12 col-sm-12 mt-3">
            <list-all-document-types
              data-vv-as="tipo documento"
              usage="aprobaciones"
              class="w-100"
              autocomplete
              label="Tipo Documento"
              name="documentType"
              v-model="step.documentType"
              ref="documentTypes"
              @input-option="onDocumentTypeChange"
            />
          </div>
          <div
            class="col-md-6 col-xs-12 col-sm-12 mt-3"
            v-if="loadingActionsOffice"
          >
            <b-spinner
              small
              variant="primary"
            />
          </div>
          <div
            class="col-md-6 col-xs-12 col-sm-12 mt-3"
            v-if="!loadingActionsOffice && documentHasOficeActions"
          >
            <b-form-group
              label="Oficina de partes que numera (*)"
            >
              <v-select
                data-vv-as="oficina que numera"
                v-validate="'required'"
                name="numerationOffice"
                :danger="errors.has('flow-part-1.numerationOffice')"
                :danger-text="errors.first('flow-part-1.numerationOffice')"
                :disabled="step.office.list.length === 1"
                v-model="step.office.selected"
                :options="step.office.list"
                @input="selectActionsOffice"
                placeholder="Selecciona una oficina"
              >
                <template slot="no-options">
                  no hay tipos de documentos para el criterio de búsqueda
                </template>
              </v-select>
              <span
                class="text-danger"
                v-if="errors.has('flow-part-1.numerationOffice')"
              >
                {{ errors.first('flow-part-1.numerationOffice') || '' }}
              </span>
              <span
                v-for="(action,$index) in step.actions"
                :key="$index+'action'"
                class="badge badge-primary ml-3"
              >
                {{ action.action }}
              </span>
            </b-form-group>
          </div>
          <div
            v-if="!isConvention && !isAguasAndinas"
            class="col-md-6 mt-3"
          >
            <vs-input
              class="w-100"
              label="Monto"
              name="amount"
              v-model="step.amount"
              :danger="errors.has('flow-part-1.amount')"
              :danger-text="errors.first('flow-part-1.amount')"
              v-validate="{ required: step.executionType === 'P' && !isConvention }"
            />
          </div>
          <div class="col-md-6 col-xs-12 col-sm-12 mt-3" v-if="isAguasAndinas && isResponse">
            <list-institution-types
              class="w-100"
              autocomplete
              label="Tipo Institución (*)"
              name="institutionType"
              v-model="step.institutionType"
              :danger="errors.has('flow-part-1.institutionType')"
              :danger-text="errors.first('flow-part-1.institutionType')"
              v-validate="'required'"
              ref="institutionType"
            />
          </div>
        </div>
        <div class="row mt-3 mb-5" v-if="isAguasAndinas && isResponse">
          <div class="col-md-12">
            <label for="matter">Materia (*)</label>
            <vs-textarea
              type="text"
              id="matter"
              label="Materia (Mínimo 3 caracteres, máximo 5000 caracteres)"
              data-cy="matter"
              name="matter"
              width="100%"
              v-validate="{
                required: isAguasAndinas && isResponse,
                min: 3
              }"
              height="100px"
              maxlength="5000"
              class="mb-0"
              v-model="step.matter"
            />
            <div class="row">
              <div class="col-md-6 text-left">
                <div
                  v-if="errors.first('flow-part-1.matter')"
                  class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
                  style="height: 32px;">
                  <span class="span-text-validation">
                    {{ errors.first('flow-part-1.matter') }}
                  </span>
                </div>
              </div>
              <div class="col-md-6 text-right">
                <span v-tooltip="'Contador de caracteres'">{{ step.matter.length }}/5000</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label>Fecha Documento</label>
            <b-form-datepicker
              today-button
              reset-button
              close-button
              v-bind="configBFormDate.labels[locale] || {}"
              :max="maxDate"
              :locale="locale"
              :show-decade-nav="false"
              :hide-header="false"
              v-model="step.issueDate"
              name="issueDate"
              data-vv-as="fecha documento"
              data-cy="issue-date"
            />
            <div
              v-if="errors.has('flow-part-1.issueDate')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;"
            >
              <span class="span-text-validation">
                {{ errors.first('flow-part-1.issueDate') }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-3 col-xs-12 col-sm-12">
            <UploadFile
              permission="*"
              accept="application/pdf, .doc, .docx, .xlsx, .ppt"
              text="Cargar Documento Principal"
              v-model="step.mainFile"
              data-cy="load-principal-document"
              upload-to="ed"
              :button-class="{ 'btn-block': true, 'mb-5': errors.has('flow-part-1.mainFileName') }"
              container-class="w-100"
              @input="addFile()"
            />
          </div>
          <div
            class="col-md-6"
            v-if="step.mainFile && Object.keys(step.mainFile).length"
          >
            <div class="d-flex flex-row align-items-center">
              <vs-icon
                icon="description"
                size="45px"
                color="primary"
              />
              <b class="text-truncate w-100">{{ step.mainFile.name }}</b>
            </div>
          </div>
          <div class="col-md-12 text-primary">
            Si va a firmar documento, favor considerar el documento principal PDF o DOCX
            (este último requiere paso revisor previo).
          </div>
        </div>
        <div class="row mb-3 mt-3">
          <div class="col-md-3 d-flex align-items-end">
            <UploadFile
              permission="*"
              text="Cargar Archivos Adjuntos"
              accept="application/pdf"
              data-cy="load-attachments-document"
              v-model="additionalFile"
              upload-to="ed"
              button-class="btn-block"
              container-class="w-100"
              @input="addAdditionalFile()"
            />
          </div>
          <div
            class="col-3"
            v-for="file in step.attachments"
            :key="file.id"
          >
            <div class="d-flex flex-column align-items-center">
              <vs-icon
                icon="description"
                size="45px"
                color="primary"
              />
              <b class="text-truncate w-100 text-center">{{ file.name }}</b>
              <vs-button
                color="danger"
                type="flat"
                icon="clear"
                @click="removeAdditionalFile(file.id)"
              />
            </div>
          </div>
        </div>
      </form>
      <form data-vv-scope="flow-part-1-2" v-if="isResponse && isAguasAndinas">
        <div class="row mb-3">
          <div class="col-12">
            <vs-divider/>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <h4>Documentos Relacionados</h4>
          </div>
          <div class="col-md-12 mb-3">
            <add-related-document @add-related-document="addRelatedDocument"/>
          </div>
          <div class="col-md-12">
            <table-related-documents
              :related-documents="step.relatedDocuments"
              v-model="step.relatedDocumentsSelected"
              multiple
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <vs-divider/>
          </div>
        </div>
      </form>
      <form data-vv-scope="flow-part-2">
        <div
          class="row mb-3 mt-4"
          v-if="step.executionType === 'P'"
        >
          <div class="col-12">
            <h4>Detalle del flujo</h4>
          </div>
        </div>
        <small
          class="text-primary"
          v-if="searchingFlow"
        > Estamos buscando la información sobre el flujo que seleccionaste </small>
        <StepsOldFlow
          v-if="step.oldFlow && oldFlow.pasos"
          :steps="oldFlow.pasos"
        />
        <div
          class="row mb-5"
          v-if="!step.oldFlow"
        >
          <div class="col-3 mt-2">
            <vs-select
              class="w-100"
              autocomplete
              label="Tipo de paso (*)"
              name="stepType"
              v-model="stepType"
              :danger="errors.has('flow-part-2.stepType')"
              :danger-text="errors.first('flow-part-2.stepType')"
              v-validate="'required'"
              @change="searchOffice"
            >
              <vs-select-item
                v-if="loadingStepTypes"
                :value="null"
                text="Cargando opciones..."
                disabled
              />
              <vs-select-item
                v-for="tipo in tiposPasoIniciarFlujo"
                :key="tipo.valor"
                :value="tipo.valor"
                :text="tipo.descripcion"
              />
            </vs-select>
          </div>
          <div
            class="col-6 mt-3"
            v-if="stepType === this.stepTypes.OFFICE"
          >
            <list-offices
              class="w-100"
              autocomplete
              label="Oficina del responsable (*)"
              name="groupStep"
              v-model="groupStep"
              :typeList="stepType"
              :officeType="wizardData.fileCategory"
              ref="groupStep"
              :danger="errors.has('flow-part-2.groupStep')"
              :danger-text="errors.first('flow-part-2.groupStep')"
              v-validate="{ required: stepType === this.stepTypes.OFFICE }"
            />
          </div>
          <div
            class="col-6 mt-3"
            v-if="stepType === stepTypes.USER"
          >
            <list-user
              class="w-100"
              autocomplete
              label="Usuario (*)"
              name="userStep"
              withFilters
              isApprovals
              v-model="userStep"
              ref="userStep"
              :danger="errors.has('flow-part-2.userStep')"
              :danger-text="errors.first('flow-part-2.userStep')"
              v-validate="{ required: stepType === stepTypes.USER }"
            />
          </div>
          <div
            class="col-4 mt-3"
            v-if="stepType === stepTypes.EXTERNAL || stepType === stepTypes.COMPLETION"
          >
            <vs-input
              class="w-100"
              label="Rut empresa o institución (*)"
              name="companyIut"
              data-vv-as="rut empresa"
              data-vv-validate-on="blur"
              data-cy="company-iut"
              placeholder="12345678-9"
              autocomplete="off"
              v-model="step.extern.iut"
              v-on:change="formatRut(step.extern, 'iut', 'companyIut')"
              :danger="errors.has('flow-part-2.companyIut')"
              :danger-text="errors.first('flow-part-2.companyIut')"
              v-validate="{ validateRut: true, required: stepType === stepTypes.EXTERNAL || stepType === stepTypes.COMPLETION }"
            />
          </div>
          <div
            class="col-4 mt-3"
            v-if="stepType === stepTypes.PERSON"
          >
            <vs-input
              class="w-100"
              label="Rut"
              name="personIut"
              data-cy="person-iut"
              placeholder="12345678-9"
              autocomplete="off"
              v-model="step.person.iut"
              :danger="errors.has('flow-part-2.personIut')"
              :danger-text="errors.first('flow-part-2.personIut')"
              v-validate="{ validateRut: true, required: stepType === stepTypes.PERSON }"
            />
          </div>
          <div
            class="col-5 mt-3"
            v-if="stepType === stepTypes.PERSON"
          >
            <vs-input
              class="w-100"
              data-vv-as="nombre"
              data-cy="person-name"
              label="Nombre"
              name="personName"
              autocomplete="off"
              v-model="step.person.name"
              :danger="errors.has('flow-part-2.personName')"
              :danger-text="errors.first('flow-part-2.personName')"
              v-validate="{ required: stepType === stepTypes.PERSON }"
            />
          </div>
          <div
            class="col-12 mt-3"
            v-if="stepType === stepTypes.PERSON"
          >
            <vs-input
              class="w-100"
              label="Correo"
              type="email"
              data-vv-as="correo"
              data-cy="person-email"
              v-model="step.person.email"
              name="personEmail"
              :danger="errors.has('flow-part-2.personEmail')"
              :danger-text="errors.first('flow-part-2.personEmail')"
              v-validate="'required|email'"
            />
          </div>
          <div
            class="col-1 text-center mt-3"
            v-if="isExternLikeStep"
          >
            <b-overlay :show="loadingCompany">
              <b-button
                v-tooltip="'Buscar empresa'"
                data-cy="search-company"
                variant="primary"
                class="btn-icon rounded-circle p-3 mt-5"
                size="sm"
                v-on:click="searchCompanyIut()"
              >
                <feather-icon icon="SearchIcon"/>
              </b-button>
            </b-overlay>
          </div>
          <div
            class="col-4 mt-3"
            v-if="externCompany.iut && isExternLikeStep"
          >
            <vs-input
              class="w-100"
              label="Razón empresa (*)"
              v-model="externCompany.razonSocial"
              name="razonSocial"
              data-cy="business-name"
              :danger="errors.has('flow-part-2.razonSocial')"
              :danger-text="errors.first('flow-part-2.razonSocial')"
              v-validate="{ required: isExternLikeStep }"
            />
          </div>
          <div
            class="col-4 mt-3"
            v-if="externCompany.iut &&
          (!newCompany && externCompany.users && externCompany.users.length) &&
           isExternLikeStep"
          >
            <div>
              Posibles firmantes
              <b-button
                v-tooltip="'Ver usuarios de la empresa'"
                variant="secondary"
                class="btn-icon rounded-circle p-3 mt-5"
                size="sm"
                v-b-modal="'users-extern-company'"
              >
                <feather-icon icon="UsersIcon"/>
              </b-button>
            </div>
          </div>
          <div
            class="col-4 mt-3"
            v-if="externCompany.iut && isExternLikeStep"
          >
            <vs-input
              class="w-100"
              label="Rut del firmante (*)"
              v-model="step.extern.responsibleIut"
              name="responsibleIut"
              data-vv-as="rut del firmante"
              data-vv-validate-on="blur"
              data-cy="responsible-iut"
              placeholder="12345678-9"
              v-on:change="formatRut(step.extern, 'responsibleIut', 'responsibleIut')"
              :danger="errors.has('flow-part-2.responsibleIut')"
              :danger-text="errors.first('flow-part-2.responsibleIut')"
              v-validate="{ validateRut: true, required: isExternLikeStep }"
            />
          </div>
          <div
            class="col-4 mt-3"
            v-if="externCompany.iut && isExternLikeStep"
          >
            <vs-input
              class="w-100"
              label="Nombre del firmante (*)"
              v-model="step.extern.responsibleName"
              name="responsibleName"
              data-vv-as="nombre del firmante"
              data-vv-validate-on="blur"
              data-cy="responsible-name"
              :danger="errors.has('flow-part-2.responsibleName')"
              :danger-text="errors.first('flow-part-2.responsibleName')"
              v-validate="{ required: isExternLikeStep }"
            />
          </div>
          <div
            class="col-4 mt-3"
            v-if="externCompany.iut && isExternLikeStep"
          >
            <vs-input
              class="w-100"
              label="Correo del firmante (*)"
              type="email"
              v-model="step.extern.responsibleEmail"
              name="responsibleEmail"
              data-vv-as="correo del firmante"
              data-vv-validate-on="blur"
              data-cy="responsible-email"
              :danger="errors.has('flow-part-2.responsibleEmail')"
              :danger-text="errors.first('flow-part-2.responsibleEmail')"
              v-validate="{ required: isExternLikeStep, email: true }"
            />
          </div>
          <div
            class="col-4 mt-3 text-primary"
            v-if="stepType === stepTypes.EXTERNAL"
          >
            <ul>
              <li>- Este tipo de paso será <b>firmante</b></li>
              <li>- Este tipo de firma será <b>firma avanzada</b></li>
            </ul>
          </div>
          <div
            class="col-4 mt-3 text-primary"
            v-if="stepType === stepTypes.COMPLETION"
          >
            <ul>
              <li>- Este tipo de paso será <b>revisor</b></li>
              <li>- El responsable <b>no firma</b>, solo completa datos</li>
              <li>- Completará los campos definidos sobre el PDF</li>
              <li>- Los campos se definen en el paso siguiente</li>
            </ul>
          </div>
          <div
            class="col-6 mt-3 text-primary"
            v-if="stepType === stepTypes.PERSON"
          >
            <ul>
              <li>- Este tipo de paso será <b>firmante</b></li>
              <li>- Este tipo de firma será <b>firma simple</b></li>
              <li>- Los datos ingresados no se pueden cambiar posteriormente</li>
            </ul>
          </div>
          <div
            class="col-3 mt-3"
            v-if="stepType !== stepTypes.OFFICE &&
              stepType !== stepTypes.EXTERNAL &&
              stepType !== stepTypes.PERSON &&
              stepType !== stepTypes.COMPLETION"
          >
            <b-form-group label="Tipo de rol (*)">
              <vs-select
                class="w-100"
                autocomplete
                name="rolType"
                v-model="rolType"
                :class="{ danger: errors.has('flow-part-2.rolType') }"
                v-validate="'required'"
              >
                <vs-select-item
                  v-for="rol in rolTypesAvalaibles"
                  :key="rol.opcionId"
                  :value="rol.valor"
                  :text="rol.descripcion"
                />
              </vs-select>
              <InfoRolType/>
              <span
                v-show="errors.has('flow-part-2.rolType')"
                class="danger span-text-validation-danger v-enter-to"
              >
                {{ errors.first('flow-part-2.rolType') }}
              </span>
            </b-form-group>
          </div>
        </div>
        <div
          class="row mb-3"
          v-if="!step.oldFlow"
        >
          <div class="col-12 d-flex align-items-end justify-content-end">
            <vs-button
              data-cy="add-step"
              color="primary"
              icon="add"
              :disabled="blockButton"
              v-on:click="addStep()"
            >
              Agregar Paso
            </vs-button>
          </div>
        </div>
        <StepsFlow
          :steps="step.steps"
          @remove-step="removeStep"
        />
        <DistributionFlow
          v-if="useDistribution"
          :distributions="step.distributions"
          @new-distribution="addDistribution"
          @remove-distribution="removeDistribution"
        />
        <div
          v-if="error.message !== ''"
          class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
          style="height: 32px;"
        >
        <span class="span-text-validation">
          {{ error.message }}
        </span>
        </div>
      </form>
      <b-modal
        id="users-extern-company"
        ref="usersExternCompany"
        :title="`Usuarios de la empresa ${externCompany.iut}`"
        cancel-title="Cancelar"
        size="lg"
      >
        <div style="height: 500px;overflow: scroll;">
          <h5>Estos usuarios ya existen en la empresa</h5>
          <div
            style="cursor: pointer;"
            v-for="user in externCompany.users"
            :key="user.id"
            class="employee-task mb-2 d-flex justify-content-between align-items-center step-box"
            v-on:click="selectUser(user)"
          >
            <b-media no-body>
              <b-media-aside class="mr-75">
                <b-avatar
                  rounded
                  v-if="user.id"
                  :text="user.nombre | avatarName"
                  size="42"
                  class="mt-25 mr-75"
                />
              </b-media-aside>
              <b-media-body class="my-auto">
                <h5 class="mb-0">
                  {{ user.nombre }}
                </h5>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75"> {{ user.correo }} </small>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </b-overlay>
</template>
<script>
// cloud/#/documentos/flujo/68483ee2201b324e08295632f39fb0458e66
import {mapActions, mapGetters} from 'vuex';

import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import ListOffices from '@/febos/chile/lists/components/ListOffices';
import ListUser from '@/febos/chile/lists/components/ListUser';
import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import StepsFlow from '@/febos/chile/approvals/wizardFlow/wizard/flow/components/StepsFlow';
import StepsOldFlow from '@/febos/chile/approvals/wizardFlow/wizard/flow/components/StepsOldFlow';
import {getUsersByGroup, ioGetCompanies} from '@/febos/servicios/api/empresas.api';
import {listOptions} from '@/febos/servicios/api/opciones.api';
import {getFile} from '@/febos/servicios/api/dnt.api';
import BooleanParameter from '@/febos/chile/tools/components/BooleanParameter';
import {getUsers} from '@/febos/servicios/api/usuarios.api';
import {rolTypes, stepTypes} from '@/febos/chile/approvals/components/trays/managementTray/constants';
import DistributionFlow from '@/febos/chile/approvals/wizardFlow/wizard/flow/DistributionFlow';
import ListAllDocumentTypes from '@/febos/chile/lists/components/ListAllDocumentTypes';
import ActionsMixin from '@/febos/chile/dnt/mixins/ActionsMixin';
import authors from '@/febos/chile/dnt/components/wizard/companies/61808000-5/utils/Authors';
import configBFormDate from '@/febos/chile/dnt/components/wizard/companies/61808000-5/utils/ConfigBFormDate';
import AddRelatedDocument from '@/febos/chile/approvals/wizardFlow/wizard/flow/components/AddRelatedDocument';
import TableRelatedDocuments from '@/febos/chile/approvals/wizardFlow/wizard/flow/components/TableRelatedDocuments';
import ListInstitutionTypes from '@/febos/chile/lists/components/ListInstitutionTypes';
import SignatureTypes from '@/febos/chile/dnt/mixins/SignatureTypes';
import InfoRolType from '@/febos/chile/approvals/wizardFlow/components/InfoRolType';
import InfoApprovalStamp from '@/febos/chile/approvals/wizardFlow/components/InfoApprovalStamp';
import InfoPrivateFlow from '@/febos/chile/approvals/wizardFlow/components/InfoPrivateFlow';
import InfoOldApproval from '@/febos/chile/approvals/wizardFlow/components/InfoOldApproval';
import {DOCX_MIME_TYPES} from '@/constants/customs_types';
import {getApprovalTemplate} from '@/febos/servicios/api/aprobaciones.api';
import RutMixin from '@/febos/chile/_vue/mixins/RutMixin';

export default {
  mixins: [WizardStep, ActionsMixin, RutMixin],
  components: {
    ListInstitutionTypes,
    InfoOldApproval,
    InfoApprovalStamp,
    InfoPrivateFlow,
    InfoRolType,
    ListAllDocumentTypes,
    BooleanParameter,
    ListUser,
    ListOffices,
    UploadFile,
    StepsFlow,
    StepsOldFlow,
    DistributionFlow,
    AddRelatedDocument,
    TableRelatedDocuments
  },
  data() {
    return {
      locale: 'es',
      externCompany: {
        users: []
      },
      searchingFlow: false,
      newCompany: false,
      newUserCompany: false,
      loadingCompany: false,
      loadingStepTypes: true,
      typeDocuments: [],
      attendedOnly: 0,
      step: {
        origin: '',
        extern: {},
        person: {},
        fileId: this.$route.params.id,
        documentType: '',
        amount: '',
        mainFile: {},
        executionType: '',
        objectType: 'ARCHIVO',
        file: '',
        consequences: [],
        matter: '',
        relatedDocumentsSelected: [],
        relatedDocuments: [],
        setAttendedOnly: false,
        ...this.draft
      },
      additionalFile: {},
      flowFile: undefined,
      authorAguasAndinas: authors,
      configBFormDate,
      disableSignaturePosition: false,
      disableDesattendedOnly: false
    };
  },
  watch: {
    wizardData(newValue) {
      this.step.description = newValue.fileResumen;
    },
    'step.mainFile': function wathStepMainFile(newValue, oldValue) {
      if (newValue.id !== oldValue.id) {
        this.step.signaturesDropped = {};
        this.removeSignaturesDropped();
      }

      if (DOCX_MIME_TYPES.includes(newValue.mime)) {
        this.step.setSignaturePosition = false;
        this.disableSignaturePosition = true;
        this.$nextTick(() => {
          this.disableDesattendedOnly = true;
          this.attendedOnly = 0;
        });
        this.onSetSignaturePositionChange(false);
      } else {
        this.disableSignaturePosition = false;
        this.disableDesattendedOnly = false;
      }
    },
    'step.setSignaturePosition': function wathStepSetSignature(newValue) {
      if (this.step.mainFile && this.step.mainFile.name && this.step.mainFile.name.toLowerCase().endsWith('.docx')) {
        this.step.setSignaturePosition = false;
        this.onSetSignaturePositionChange(false);
      }
      if (!newValue) {
        if (this.thereAreSignatureStep) {
          this.step.setSignaturePosition = true;
          this.onSetSignaturePositionChange(true);
        }
      }
    },
    'step.setAttendedOnly': function watchAttendedOnly(newValue) {
      if (!newValue) {
        this.step.setAttendedOnly = true;
        this.attendedOnly = 0;
      }
    },
    'step.oldFlow': function watchOldFlow(newValue) {
      if (!newValue) {
        this.step.flowId = undefined;
      }
    },
    attendedOnly() {
      this.step.flowId = undefined;
    }
  },
  computed: {
    ...mapGetters('List', [
      'groupUsersState',
      'userGroupsState',
      'officesState'
    ]),
    ...mapGetters('Approvals', [
      'wizardData',
      'approvalsTemplates',
      'stepTypesOptions',
      'stepRoles'
    ]),
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
    filteredApprovalsTemplates() {
      return this.approvalsTemplates.filter((item) => item.desatendida === this.attendedOnly);
    },
    isResponse() {
      return this.$route.query.origin === 'respuesta';
    },
    maxDate() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return new Date(today);
    },
    actualStepType() {
      const tipes = this.stepTypesOptions;
      const stepType = tipes.find((item) => item.valor == this.stepType);
      return stepType;
    },
    rolTypesAvalaibles() {
      const stepType = this.actualStepType;
      if (stepType && stepType.tipoRol && stepType.tipoRol.length > 0) {
        const avalaiblesTipesId = stepType.tipoRol;
        return this.stepRoles.filter((item) => avalaiblesTipesId.includes(item.valor));
      }
      return this.stepRoles;
    },
    // Completitud reutiliza la UI de Externo (empresa + firmante por RUT).
    isExternLikeStep() {
      return this.stepType === this.stepTypes.EXTERNAL
        || this.stepType === this.stepTypes.COMPLETION;
    },
    // Tipos de paso ofrecidos en el wizard de iniciar flujo: los habilitados
    // (getStepTypes ya filtra deshabilitado=0) marcados con extra.iniciarFlujo.
    // Se deduplican por valor (la tabla opciones puede tener filas repetidas).
    tiposPasoIniciarFlujo() {
      const vistos = new Set();
      return (this.stepTypesOptions || [])
        .filter((opt) => opt && opt.iniciarFlujo === true)
        .filter((opt) => {
          if (vistos.has(opt.valor)) {
            return false;
          }
          vistos.add(opt.valor);
          return true;
        });
    },
  },
  methods: {
    ...mapActions('List', [
      'fetchUserGroups',
      'fetchOffices'
    ]),
    ...mapActions('Approvals', [
      'getApprovalsTemplates',
      'removeSignaturesDropped',
      'getStepTypes',
      'getStepRoles'
    ]),
    async addRelatedDocument(row) {
      const isSelected = this.step.relatedDocumentsSelected
        .some((relatedDoc) => relatedDoc.id === row.id
          && relatedDoc.type === row.type && relatedDoc.number === row.number);

      if (!isSelected) {
        this.step.relatedDocuments.push(row);
        this.step.relatedDocumentsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste esta referencia',
          {
            title: '¡HEEEY!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    formatRut(target, field, fieldName) {
      if (target && target[field]) {
        this.$set(target, field, this.formatear(target[field], false));
        if (fieldName) {
          this.$nextTick(() => {
            this.$validator.validate(`flow-part-2.${fieldName}`);
          });
        }
      }
    },
    selectUser(user) {
      this.newUserCompany = false;
      this.step = {
        ...this.step,
        extern: {
          iut: this.externCompany.iut,
          responsibleName: user.nombre,
          responsibleIut: user.iut,
          responsibleEmail: user.correo
        }
      };
      this.$refs.usersExternCompany.hide();
    },
    async searchCompanyIut() {
      if (this.company.iut === this.step.extern.iut) {
        this.$bvToast.toast(
          'No puedes colocar el mismo rut de la empresa en la que estás',
          {
            title: '¡Hey!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000
          }
        );
        this.step.extern.iut = '';
        return;
      }
      if (!this.step.extern.iut) {
        this.$bvToast.toast(
          'Ingresa un rut para buscar su información',
          {
            title: '¡Hey!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000
          }
        );
        return;
      }
      this.loadingCompany = true;
      const {data} = await ioGetCompanies({
        pagina: 1,
        filas: 100,
        filtro: this.step.extern.iut.includes('-')
          ? `iut$${this.step.extern.iut.split('-')[0]}` : `iut$${this.step.extern.iut}`,
        simular: 'no',
        usaFiltros: 'si',
        busquedaSimple: 'no',
        ambito: 'cloud'
      });
      this.loadingCompany = false;
      if (data.empresas && data.empresas.length) {
        const [companies] = data.empresas;
        this.newCompany = false;
        this.externCompany = companies;
        const response = await getUsers({
          buscarEnEmpresaId: this.externCompany.id,
          filas: 10000,
          pagina: 1
        });
        this.externCompany = {...this.externCompany, users: response.data.usuarios};
      } else {
        this.newCompany = true;
        this.newUserCompany = true;
        this.externCompany = {
          iut: this.step.extern.iut,
          users: []
        };
      }
    },
    async addAdditionalFile() {
      if (!Object.keys(this.additionalFile).length) {
        return;
      }

      if (this.additionalFile.failed) {
        // TODO: display error message.
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.step.attachments.push(this.additionalFile);
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.step.attachments = this.step.attachments.filter((file) => file.id !== fileId);
    },
    async addFile() {
      this.blockButton = false;
      this.error.message = '';
      if (this.step.mainFile.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        this.step.mainFile = {};
      }
      await this.$validator.reset();
    },
    searchOffice() {
      if (this.stepType === StepTypes.OFFICE) {
        const typeOffice = this.wizardData.fileCategory === 'numOf' ? 'ext' : 'int';
        const offices = this.userGroupsState.list.filter(
          (group) => group.isOffice === 'Y' && group.type === typeOffice
        );
        if (offices.length) {
          this.groupStep = offices[0].id;
        }
      }
    },
    async addExternStep() {
      const isExistentUser = this.externCompany.users && this.externCompany.users.length
        && this.externCompany.users.some((user) => user.iut === this.step.extern.responsibleIut);
      const step = {
        esNuevaEmpresa: this.newCompany,
        esNuevoUsuario: this.newCompany ? true : !isExistentUser,
        data: {
          grupoUsuarios: [],
          tipoValorResponsableId: this.step.extern.iut + (this.step.steps.length + 1),
          responsable: {
            correo: this.step.extern.responsibleEmail,
            nombre: this.step.extern.responsibleName,
            rut: this.step.extern.responsibleIut
          },
          aprobacionesTipoRolId: this.rolTypes.SIGNER,
          aprobacionesTipoPasoId: this.stepType,
          tipoPaso: {
            id: this.stepType,
            nombre: stepTypes[this.stepType]
          },
          tipoRol: {
            id: this.rolTypes.SIGNER,
            nombre: rolTypes[this.rolTypes.SIGNER]
          },
          index: this.step.steps.length + 1,
          extra: {
            empresa: {
              iut: this.step.extern.iut,
              razon: this.externCompany.razonSocial
            }
          }
        },
        stepType: this.stepType,
        rolType: this.rolTypes.SIGNER,
        stepNumber: this.step.steps.length + 1,
        responsibleName: this.step.extern.responsibleName,
        responsibleId: this.step.extern.responsibleIut,
        responsibleEmail: this.step.extern.responsibleEmail,
        responsableTerceroIut: this.step.extern.iut,
        responsableTerceroNombre: this.step.extern.responsibleName,
        tipoFirma: SignatureTypes.FEA
      };

      this.step.steps.push(step);

      this.stepType = this.stepTypes.USER;
      this.rolType = '';
      this.groupStep = '';
      this.userStep = '';
      this.step.extern = {};
      this.externCompany = {};
      this.blockButton = false;
      await this.$validator.reset();
    },
    async addCompletionStep() {
      // Completitud de datos: identifica al responsable como Externo (empresa +
      // firmante por RUT), pero con rol REVISOR y SIN firma. Los campos a
      // completar se definen en el paso 2 (constructor) a nivel de flujo.
      const isExistentUser = this.externCompany.users && this.externCompany.users.length
        && this.externCompany.users.some((user) => user.iut === this.step.extern.responsibleIut);
      const step = {
        esNuevaEmpresa: this.newCompany,
        esNuevoUsuario: this.newCompany ? true : !isExistentUser,
        completionStep: true,
        data: {
          grupoUsuarios: [],
          tipoValorResponsableId: this.step.extern.iut + (this.step.steps.length + 1),
          responsable: {
            correo: this.step.extern.responsibleEmail,
            nombre: this.step.extern.responsibleName,
            rut: this.step.extern.responsibleIut
          },
          aprobacionesTipoRolId: this.rolTypes.REVIEWER,
          aprobacionesTipoPasoId: this.stepType,
          tipoPaso: {
            id: this.stepType,
            nombre: stepTypes[this.stepType]
          },
          tipoRol: {
            id: this.rolTypes.REVIEWER,
            nombre: rolTypes[this.rolTypes.REVIEWER]
          },
          index: this.step.steps.length + 1,
          extra: {
            empresa: {
              iut: this.step.extern.iut,
              razon: this.externCompany.razonSocial
            }
          }
        },
        stepType: this.stepType,
        rolType: this.rolTypes.REVIEWER,
        stepNumber: this.step.steps.length + 1,
        responsibleName: this.step.extern.responsibleName,
        responsibleId: this.step.extern.responsibleIut,
        responsibleEmail: this.step.extern.responsibleEmail,
        responsableTerceroIut: this.step.extern.iut,
        responsableTerceroNombre: this.step.extern.responsibleName
      };

      this.step.steps.push(step);

      // Aloja los campos a nivel de flujo y recalcula las condiciones del
      // wizard para activar el paso 2 (constructor de campos).
      if (!Array.isArray(this.step.completionFields)) {
        this.$set(this.step, 'completionFields', []);
      }
      this.$emit('update-steps');

      this.stepType = this.stepTypes.USER;
      this.rolType = '';
      this.groupStep = '';
      this.userStep = '';
      this.step.extern = {};
      this.externCompany = {};
      this.blockButton = false;
      await this.$validator.reset();
    },
    async addPersonStep() {
      const step = {
        data: {
          gruposUsuarios: [],
          tipoValorResponsableId: this.step.person.iut + (this.step.steps.length + 1),
          responsable: {
            correo: this.step.person.email,
            nombre: this.step.person.name,
            rut: this.step.person.iut
          },
          aprobacionesTipoRolId: this.rolTypes.SIGNER,
          aprobacionesTipoPasoId: this.stepType,
          tipoPaso: {
            id: this.stepType,
            nombre: stepTypes[this.stepType]
          },
          tipoRol: {
            id: this.rolTypes.SIGNER,
            nombre: rolTypes[this.rolTypes.SIGNER]
          },
          index: this.step.steps.length + 1
        },
        stepType: this.stepType,
        rolType: this.rolTypes.SIGNER,
        stepNumber: this.step.steps.length + 1,
        responsibleName: this.step.person.name,
        responsibleIut: this.step.person.iut,
        responsibleId: this.step.person.iut,
        responsibleEmail: this.step.person.email,
        tipoFirma: SignatureTypes.FES
      };
      this.step.steps.push(step);

      if (this.thereAreSignatureStep) {
        this.disableSignaturePosition = true;
        this.step.setSignaturePosition = true;
        this.onSetSignaturePositionChange(true);
      }

      this.stepType = this.stepTypes.USER;
      this.rolType = '';
      this.groupStep = '';
      this.userStep = '';
      this.step.person = {};
      this.blockButton = false;
      await this.$validator.reset();
    },
    async addStep() {
      this.error.message = '';
      this.blockButton = true;
      const isValid = await this.validateForm('flow-part-2');

      if (!isValid) {
        this.blockButton = false;
        return;
      }

      if (this.stepType === StepTypes.EXTERNAL) {
        this.step.setSignaturePosition = true;
        this.disableSignaturePosition = true;
        this.onSetSignaturePositionChange(true);
        await this.addExternStep();
        return;
      }

      if (this.stepType === StepTypes.PERSON) {
        await this.addPersonStep();
        return;
      }

      if (this.stepType === StepTypes.COMPLETION) {
        await this.addCompletionStep();
        return;
      }

      const responsibleStep = (
        this.stepType === StepTypes.GROUP
      )
        ? this.$refs.groupStep.getOption()
        : this.$refs.userStep.getOption();

      if (this.step.steps.some((step) => (
        step.rolType === this.rolType
        && step.responsibleId === responsibleStep.id
      ))) {
        this.error.message = 'Ya existe un paso con ese responsable';
        this.blockButton = false;
        return;
      }

      const step = {
        stepType: this.stepType,
        rolType: this.rolType,
        stepNumber: this.step.steps.length + 1,
        responsibleName: responsibleStep.label,
        responsibleId: responsibleStep.id,
        responsibleEmail: responsibleStep.email || '',
        page: null,
        x: null,
        y: null
      };

      if (this.stepType === StepTypes.GROUP) {
        const {data: {usuarios: users}} = await getUsersByGroup({
          empresaId: this.company.id,
          pagina: 1,
          filas: 9999,
          groupId: responsibleStep.id
        });

        step.groupUsers = users.map((user) => ({
          ...user,
          tipoValorResponsableId: user.id
        }));
      }

      this.step.steps.push(step);

      // Recalcula las condiciones del wizard (p. ej. activar el paso 2 del
      // constructor de campos cuando se agrega un paso de completitud).
      this.$emit('update-steps');

      this.stepType = this.stepTypes.USER;
      this.rolType = '';
      this.groupStep = '';
      this.userStep = '';
      this.blockButton = false;
      await this.$validator.reset();
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async isValid() {
      const isDocxFile = DOCX_MIME_TYPES.includes(this.step.mainFile.mime);
      if (isDocxFile && this.validIfStepsHasSigner()) {
        if (this.step.steps.length === 0 && this.step.flowId) {
          const isTemplateValid = await this.validateTemplateSteps();
          if (!isTemplateValid) {
            return false;
          }
        } else {
          if (!this.hasReviewer(this.step.steps)) {
            this.error.message = 'Para transformar a PDF debe tener un revisor';
            return false;
          }
          if (!this.checkReviewerBeforeSigner(this.step.steps)) {
            this.error.message = 'Debe haber al menos un revisor antes del primer firmante en el flujo';
            return false;
          }
        }
      }
      if (this.searchingConfig) {
        return false;
      }
      try {
        this.searchingConfig = true;
        this.blockButton = false;
        this.error.message = '';
        const formValid = await this.validateForm('flow-part-1');

        if (!formValid) {
          return false;
        }
        if (!this.step.mainFile.name) {
          this.error.message = 'Debes agregar el documento para el flujo';
          return false;
        }
        this.checkIfFlowHasSteps();
        this.checkIfLastStepsIsRevisor();
        this.checkIfHasSignaturePositionActiveAndSignerStep();
        this.checkSignatureIfFileIsAcepted();
        if (this.loadingActionsOffice) {
          this.error.message = 'Se esta verificando la oficina asignada';
        }
        const {documentHasOficeActions} = this;
        if (documentHasOficeActions) {
          const isNumerationValid = await this.validNumerationActionConfigDocNum();
          if (!isNumerationValid) {
            this.error.message = 'No existe configuración de numeración para este documento';
            return false;
          }
          const hasSigner = this.validIfStepsHasSigner();
          if (!hasSigner) {
            this.error.message = 'No se puede realizar las acciones de la oficina con pasos sin firmante';
            return false;
          }
        }
        this.adjustStepsNumbers();
        return true;
      } finally {
        this.searchingConfig = false;
      }
    },

    transformTemplateSteps(templateSteps) {
      return templateSteps.map((step) => ({
        ...step,
        rolType: parseInt(step.aprobacionesTipoRolId, 10)
      }));
    },

    async validateTemplateSteps() {
      try {
        const [response] = await Promise.all([
          getApprovalTemplate({id: this.step.flowId})
        ]);
        const templateSteps = response.data?.aprobacion?.pasos || [];
        const transformedSteps = this.transformTemplateSteps(templateSteps);

        if (!this.hasReviewer(transformedSteps)) {
          this.error.message = 'Para transformar a PDF debe tener un revisor';
          return false;
        }
        if (!this.checkReviewerBeforeSigner(transformedSteps)) {
          this.error.message = 'Debe haber al menos un revisor antes del primer firmante en el flujo';
          return false;
        }
        return true;
      } catch (error) {
        console.error('Error al ejecutar', error);
        this.error.message = 'Error al obtener la plantilla';
        return false;
      }
    },

    hasReviewer(steps) {
      return steps.some((step) => step.rolType === this.rolTypes.REVIEWER);
    },

    checkReviewerBeforeSigner(steps) {
      const signerIndex = steps.findIndex((step) => step.rolType === this.rolTypes.SIGNER);
      if (signerIndex === -1) {
        return true;
      }
      const hasReviewerBeforeSigner = steps.slice(0, signerIndex)
        .some((step) => step.rolType === this.rolTypes.REVIEWER);
      return hasReviewerBeforeSigner;
    },

    getStepData() {
      const institutionTypeName = this.step.institutionType
        ? {
          institutionTypeName: this.$refs.institutionType.getOption()?.label
        }
        : {};
      return {
        ...this.step,
        ...institutionTypeName
      };
    },
    onSetSignaturePositionChange(newValue) {
      this.$emit('update-steps');
      this.$emit('loaded');

      if (!newValue) {
        this.step.signaturesDropped = {};
        this.removeSignaturesDropped();
      }
    },
    addDistribution(distribution) {
      this.step.distributions.push(distribution);
    },
    removeDistribution(index) {
      this.step.distributions.splice(index, 1);
    },
    onDocumentTypeChange(option) {
      this.step.office.list = [];
      this.step.documentTypeId = option?.id;
      if (this.isConvention) {
        this.checkIfDocumentHasAutomaticNumerationActions(option);
      }
    },
    selectActionsOffice(office) {
      this.addActionsOffice(office, this.step.office.documentInfo);
    }

  },
  async mounted() {
    this.step.origin = this.$route.query.origin;
    this.step.numberReference = this.$route.query.numero;
    const fileFebosId = this.$route.query.febosId;

    if (fileFebosId) {
      this.searchingConfig = true;
      this.$vs.notify({
        title: 'Danos unos minutos,',
        text: 'Estamos buscando la información con el expediente relacionado',
        color: 'success',
        time: 3000,
        position: 'top-center'
      });
      const {data} = await getFile({
        febosId: fileFebosId,
        retornarDnt: 'si',
        destinatarios: 'no',
        metadata: 'si',
        etiquetas: 'no',
        referencias: 'no',
        adjuntos: 'no'
      });

      this.flowFile = data;
      this.step.fileData = this.flowFile;

      this.searchingConfig = false;
    }

    if (this.flowFile) {
      this.step.references.push({
        documentoId: this.flowFile.dnt.febosId,
        fecha: this.flowFile.dnt.fechaEmision || this.flowFile.fechaCreacion,
        folio: this.flowFile.dnt.numero,
        tipoDocumento: 'EXP'
      });
      if (this.isAguasAndinas) {
        this.step.consequences = [
          'c6ec83a8-775a-11e9-aed6-1212502775a',
          'c6ec83a8-775a-11e9-aed6-1212502775aa',
          'c6ec83a8-775a-11e9-aed6-1212502775ab',
          'c6ec83a8-775a-11e9-aed6-1212502775ab',
          'c6ec83a8-775a-11e9-aed6-1212502775ac'
        ];
      }
    } else if (this.step.numberReference) {
      this.step.references.push({
        folio: this.step.numberReference,
        tipoDocumento: 'EXP'
      });
      if (this.isAguasAndinas) {
        this.step.consequences = [
          'c6ec83a8-775a-11e9-aed6-1212502775a',
          'c6ec83a8-775a-11e9-aed6-1212502775aa',
          'c6ec83a8-775a-11e9-aed6-1212502775ab',
          'c6ec83a8-775a-11e9-aed6-1212502775ab',
          'c6ec83a8-775a-11e9-aed6-1212502775ac'
        ];
      }
    }
    if (this.thereAreSignatureStep) {
      this.disableSignaturePosition = true;
      this.step.setSignaturePosition = true;
      this.onSetSignaturePositionChange(true);
    }

    if (this.isResponse && this.isAguasAndinas) {
      this.step.documentType = 'CARTA';
      this.step.matter = this.flowFile.observaciones.length ? this.flowFile.observaciones[0]?.observacion : '';
    }
  },
  async created() {
    try {
      await this.getStepTypes();
    } finally {
      this.loadingStepTypes = false;
    }
    await this.getStepRoles();
    this.blockButton = false;
    this.searchingFlow = false;
    await this.fetchUserGroups();
    await this.getApprovalsTemplates({
      params: {
        filtros: `iutEmpresa:${this.company.id}|aprobacionesEstado:Y|filtrarUnidad:Y|tipoObjeto:ARCHIVO|app:ED`,
        pagina: 1,
        orden: '-fechaCreacion',
        itemsPorPagina: 2000
      }
    });
    const typeDocuments = await listOptions({
      grupoOpcion: 'tipos.doc-adjuntos-ed',
      deshabilitado: 'no'
    });
    this.typeDocuments = typeDocuments.data.opciones;
  }
};
</script>
